// extracted by mini-css-extract-plugin
export default {"root":"_3jXAjtDm","input":"_1yUSEa9p","send":"_1EeBNq5H","assign":"u9-PuNNc"};